module.exports = __webpack_public_path__ + "img/1.de88e087.jpg";